var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoSecondary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 32,
    viewBox: "0 0 43 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7523 2.12628C19.3684 -0.708759 23.4095 -0.708759 25.0256 2.12628C26.6425 4.96131 24.6219 8.50511 21.3889 8.50511C18.1559 8.50511 16.1354 4.96131 17.7523 2.13003V2.12628Z",
    fill: "url(#paint0_linear_369_21333)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1142 15.7607L25.907 17.9935L23.6517 20.2765L23.6465 20.2818C23.0687 20.8646 22.2926 21.2015 21.4774 21.2235C20.6622 21.2456 19.8695 20.951 19.2618 20.4003C19.2568 20.395 19.2514 20.3902 19.2455 20.386L19.0292 20.1678C19.0248 20.1625 19.0203 20.1558 19.0151 20.1505L16.8813 17.992L13.6223 14.6972L7.90144 20.4873L13.6231 26.2766C13.9256 26.5751 14.1666 26.9315 14.332 27.3251C14.4975 27.7187 14.5841 28.1416 14.5868 28.5694C14.5895 28.9971 14.5083 29.4212 14.3479 29.8169C14.1875 30.2126 13.951 30.5721 13.6523 30.8745C13.3536 31.177 12.9985 31.4163 12.6077 31.5787C12.2169 31.7411 11.7982 31.8232 11.3757 31.8204C10.9533 31.8176 10.5357 31.7298 10.147 31.5623C9.75836 31.3947 9.40644 31.1506 9.11169 30.8442L1.25027 22.8888L1.24286 22.8813L1.02066 22.6563C1.01934 22.6562 1.01811 22.6556 1.01717 22.6546C1.01623 22.6537 1.01563 22.6524 1.01548 22.6511C0.467927 22.0366 0.174312 21.2327 0.195263 20.4053C0.216213 19.5779 0.550129 18.7903 1.12806 18.205L11.2078 8.00488L11.5366 7.67262C12.1135 7.16827 12.8495 6.8896 13.6116 6.88698C14.3737 6.88437 15.1116 7.15799 15.6918 7.65837L16.051 8.01913L21.3912 13.4252L23.4828 15.5417C23.5013 15.5627 23.5176 15.5822 23.5369 15.6032C23.6073 15.6782 23.6776 15.7532 23.7524 15.8215L23.8139 15.8762C24.4162 16.4011 25.1901 16.6797 25.9844 16.6578C26.7788 16.6359 27.5365 16.315 28.1098 15.7577L28.1142 15.7607Z",
    fill: "url(#paint1_linear_369_21333)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6899 22.7366L33.6907 30.8262C33.6792 30.8404 33.6668 30.8539 33.6537 30.8667C33.6396 30.8809 33.6278 30.8929 33.6137 30.9049C33.0105 31.5058 32.1964 31.8393 31.3503 31.8323C30.5043 31.8253 29.6956 31.4782 29.1023 30.8674C28.509 30.2567 28.1795 29.4322 28.1865 28.5755C28.1934 27.7188 28.5362 26.8999 29.1393 26.2991L34.8617 20.5105L29.1408 14.7205L28.1994 15.6722C28.1713 15.7037 28.1409 15.7345 28.1105 15.763C27.5373 16.3202 26.7796 16.6411 25.9852 16.663C25.1909 16.685 24.417 16.4063 23.8147 15.8815L23.648 15.715L23.4836 15.547L21.392 13.4304L23.6436 11.1527L26.6403 8.12188L27.1706 7.58487C27.7314 7.13701 28.4244 6.89269 29.1385 6.89106C29.8527 6.88943 30.5468 7.13058 31.1095 7.57587L41.9128 18.5088C42.3856 19.1222 42.6234 19.8879 42.5824 20.6649C42.5414 21.4419 42.2245 22.1776 41.6899 22.7366Z",
    fill: "url(#paint2_linear_369_21333)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_369_21333",
    x1: 17.7923,
    y1: 1.44752,
    x2: 24.8507,
    y2: 6.81379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFD34B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EFC04B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFBB78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_369_21333",
    x1: 0.1963,
    y1: 19.3398,
    x2: 28.1142,
    y2: 19.3398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#218AAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#5DC8CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E9995"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_369_21333",
    x1: 21.392,
    y1: 19.351,
    x2: 42.5868,
    y2: 19.351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFD34B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EFC04B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFBB78"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSecondary);
export default __webpack_public_path__ + "static/media/logoSecondary.04fb0e7af345b51f4e616ea5a1059f03.svg";
export { ForwardRef as ReactComponent };